<template>
  <div>
    <van-popup v-model="show" class="popup__advert" closeable duration="0.05" @close="close">
      <!-- 广告弹窗 -->
      <div v-if="imageUrl" class="zjs__advert">
        <a
          v-trackevent="{
            type: 'funcTracker',
            action: 'click',
            opt_label: '弹窗_首页',
            opt_value: link
          }"
          :href="link"
          :class="{ outerAd: needAdPrint }"
        >
          <img :src="imageUrl" />
        </a>
        <div class="zjs-advert-close" @click.stop>
          <div @click.stop="show = false">
            <img src="./img/close.png" />
          </div>
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
import { register } from '@/plugin/popup'
// import { getMopaAd } from '@/api/ad'
export default {
  data() {
    return {
      show: false,
      imageUrl: null,
      link: null,
      needAdPrint: null
    }
  },
  mounted() {
    register({
      name: 'Advert',
      open: ({ afterClose, imageUrl, link, needAdPrint }) => {
        this.afterClose = afterClose
        this.$trackevent({
          type: 'funcTracker',
          action: 'show',
          opt_label: '弹窗_首页'
        })
        if (!imageUrl) {
          return this.close()
        } else {
          this.imageUrl = imageUrl
          this.link = link
          this.needAdPrint = needAdPrint
          this.show = true
        }
      },
      close: () => {
        this.close()
      }
    })
  },
  methods: {
    close() {
      this.show = false
      if (this.afterClose) {
        this.afterClose()
      }
    }
  }
}
</script>
<style lang="scss">
.popup__advert.van-popup {
  background-color: transparent;
  width: 70%;
}
.popup__advert .van-popup__close-icon--top-right {
  display: none;
  position: absolute;
  top: 2.96rem;
  right: 0.44rem;
  font-size: 0.4rem;
}
</style>
<style lang="scss" scoped>
.zjs__advert {
  position: relative;
  width: 100%;

  a {
    display: block;

    img {
      display: block;
      width: 100%;
    }
  }

  .zjs-advert-close {
    width: 100%;
    display: flex;
    justify-content: center;
    padding-top: 20px;

    div {
      width: 10%;

      img {
        display: block;
        width: 100%;
      }
    }
  }

  .outerAd {
    position: relative;
  }

  .outerAd::before {
    content: '广告';
    width: 29px;
    height: 16px;
    line-height: normal;
    display: flex;
    justify-content: center;
    align-items: center;
    position: absolute;
    z-index: 11;
    left: 0px;
    top: 0px;
    font-family: PingFangSC, Sans-serif, -apple-system, Arial, sans-serif !important;
    font-size: 10px !important;
    background: rgba(0, 0, 0, 0.2);
    border-radius: 2px;
    color: #ffffff;
  }
}
</style>
